import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { GetTokenResponse } from '../../models/intefaces/get-token-response';
import { CanvasComponent } from '../canvas/canvas.component';
import { FileType, getFileName } from '../../models/enums/file-type';
import {
  Target,
  VerificationService,
} from '../../services/verification/verification.service';
import { FormFileInput } from '../../models/form-file-input';
import { FileReaderService } from '../../services/file-reader/file-reader.service';
import { TranslationsService } from '../../services/translations/translations.service';
import { GetBroadcastData } from 'src/app/models/intefaces/get-broadcast-data';

import resizeImage from '../../services/image-resize';

enum View {
  idCard,
  sign,
}

@Component({
  selector: 'app-mobile-verification',
  templateUrl: './mobile-verification.component.html',
  styleUrls: ['./mobile-verification.component.scss'],
})
export class MobileVerificationComponent implements OnInit {
  token: GetTokenResponse = { token: '', code: '' };

  isSubmit: boolean = false;
  sign = View.sign;
  idCard = View.idCard;

  view = View.idCard;

  readonly front = FileType.front;
  readonly back = FileType.back;
  readonly signature = FileType.signature;

  public readonly formFileInput: FormFileInput[] = [];

  @ViewChild(CanvasComponent)
  canvas?: CanvasComponent;

  private code?: string;

  public broadcast?: any = [];

  public loading?: boolean = false;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly httpClient: HttpClient,
    private readonly verificationService: VerificationService,
    private readonly fileReader: FileReaderService,
    private readonly translationsService: TranslationsService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(
        switchMap((paramMap) => {
          this.code = paramMap.get('code') as string;
          return this.httpClient.get<GetTokenResponse>(this.getUrl());
        })
      )
      .subscribe((token) => this.onTokenResponse(token));
  }

  private getUrl(): string {
    return `${this.translationsService.getCurrentLanguage()}/form/getToken/${
      this.code
    }`;
  }

  private onTokenResponse(token: GetTokenResponse): void {
    this.token = token;

    this.verificationService.setToken(this.token.token);
  }

  hasSignature(): boolean {
    return this.canvas?.hasDrawing() || false;
  }

  onFileReady(file: File, type: FileType): void {
    this.formFileInput[type] = new FormFileInput(file, getFileName(type));
    // this.formFileInput[type].read(this.fileReader).then(() => {
    //   this.verificationService.addValue(
    //     this.formFileInput[type].getInputName(),
    //     this.formFileInput[type].getBlob()
    //   );
    // });
    this.formFileInput[type].getBase64(this.fileReader).then((base64) => {
      const imageFile = new Image();
      imageFile.src = base64;
      
      imageFile.onload = async () => {
        const data = resizeImage(imageFile, (blob: Blob) => {
          this.verificationService.addValue(this.formFileInput[type].getInputName(), blob);
        });

        this.broadcast[type] = data;
      }
    });
  }

  isDirty(): boolean {
    return this.isFirstStepDirty();
  }

  private isFirstStepDirty(): boolean {
    return (
      !this.hasSignature() &&
      (!this.formFileInput[FileType.front] ||
        !this.formFileInput[FileType.back])
    );
  }

  next(): void {
    if (this.view !== View.sign) {
      this.view = View.sign;
    } else {
      this.loading = true;
      this.verificationService.addSignature(this.canvas?.getDrawing() || '');
      this.verificationService.send(Target.camera)
        .subscribe(
          () => {
            this.loading = false;
            this.isSubmit = true;
          }, 
          err => console.log({ err })
        );
    }
  }

  reset(): void {
    if (this.canvas instanceof CanvasComponent) {
      this.canvas.reset();
    }
  }

}
